import { render, staticRenderFns } from "./App.Default.vue?vue&type=template&id=e7f20b9c&scoped=true"
import script from "./App.Default.vue?vue&type=script&lang=js"
export * from "./App.Default.vue?vue&type=script&lang=js"
import style0 from "./App.Default.vue?vue&type=style&index=0&id=e7f20b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f20b9c",
  null
  
)

export default component.exports